import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ProgressiveBonusesBoard from "./components/ProgressiveBonusesBoard";
import useProgressiveBonuses from "./useProgressiveBonuses";
import "./progressiveBonuses.css";

function ProgressiveBonusesDisplay() {
  const { bonuses, error, isLoading, loadBonuses } = useProgressiveBonuses({ pollInterval: 30000 });

  if (isLoading) {
    return (
      <main className="progressive-bonuses-display progressive-bonuses-display--status">
        <CircularProgress sx={{ color: "#d8a921" }} />
        <p>Loading progressive bonuses…</p>
      </main>
    );
  }

  if (error) {
    return (
      <main className="progressive-bonuses-display progressive-bonuses-display--status">
        <p>{error}</p>
        <button type="button" onClick={() => loadBonuses()}>Try again</button>
      </main>
    );
  }

  return (
    <main className="progressive-bonuses-display">
      <ProgressiveBonusesBoard bonuses={bonuses} projection />
    </main>
  );
}

export default ProgressiveBonusesDisplay;
